// extracted by mini-css-extract-plugin
module.exports = {"badgewrapper":"styles_badgewrapper__pS0rt","icon":"styles_icon__8GKzc"};
module.exports.__checksum = "e3aed3798344"
